import { useQuery } from '@tanstack/react-query';

import { useAuth } from './use-auth';

import { getBusinessContext } from '@/services/businessContextService';

export function useBusinessContext() {
  const { user } = useAuth();

  const {
    data: businessContext,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['business-context', user?.id],
    queryFn: getBusinessContext,
    enabled: !!user,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    businessContext,
    isLoading,
    error,
    industry: businessContext?.industry || 'general',
    hasCompetitors: (businessContext?.competitors?.length || 0) > 0,
  };
}
